import Lightbox from "@components/Lightbox/Lightbox";
import clsx from "clsx";
import { FC } from "react";
import styles from "./QuoteModal.module.scss";

export type Props = {
  className?: string;
  onClose: () => void;
  shortQuote: string;
  longQuote?: string;
  authorName: string;
  authorJobTitle: string;
};

const QuoteModal: FC<Props> = ({
  shortQuote,
  authorJobTitle,
  authorName,
  onClose,
  longQuote,
  className,
}) => {
  return (
    <Lightbox
      customClass={clsx("quote-lightbox", className)}
      onCloseFunction={onClose}
    >
      <div
        className={clsx(
          styles["overlay-content"],
          styles["long-quote-overlay"]
        )}
      >
        <div
          className={clsx(
            "wrapper",
            styles["long-quote-content"],
            styles["popup"]
          )}
        >
          <div className={styles["qt-line"]}></div>
          <p>
            {shortQuote + (longQuote || "")}
            <br />
            <br />
            <b>{authorName}</b>, {authorJobTitle}
          </p>

          <div className={styles["qt-second-line"]}></div>
        </div>
      </div>
    </Lightbox>
  );
};

export default QuoteModal;
